import {EUIFRConnections} from '../actions/fr-actions';
export const initialFRState: IFRState = {
  frConfiguration: false,
  frConfigurations: []
};

export function FRReducer(state = initialFRState, action: any): IFRState {
  switch (action.type) {


    case EUIFRConnections.UpdateFRConfigurationSuccess : {
      const newState = {...state, frConfiguration: action.payload};
      return newState;
    }
    case EUIFRConnections.GetFRConfigurationsSuccess : {
      const newState = {...state, frConfigurations: action.payload};
      return newState;
    }
    default: {
      return state;
    }
  }
}


